import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import Bet from '@/Models/Bet.js';
// Constants
import { ExoticBetTypes } from '@/Constants/Bet.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let meta = { pagination: {} };

	const { subscribe, set, update } = writable(collect());

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getExoticBetsForRace(raceId, pagination = null, betTypeFilter = null) {
			let bet = new Bet();
			// we need a custom resource URL for this endpoint
			bet.resourceUrl = () => {
				return `${bet.baseUrl()}/races/${raceId}/bets`;
			};

			if (betTypeFilter) {
				bet = bet.where('type_id', betTypeFilter.join(','));
			} else {
				bet = bet.where('type_id', ExoticBetTypes.join(','));
			}

			let results = pagination ? bet.paginate(pagination.size, pagination.number) : bet.all();
			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
